import { useScrollTo } from '@nandorojo/anchor';
import { lazy, Suspense, useEffect } from 'react';

const Entry = lazy(() => import('@/screens/Entry'));

const HomeScreen = () => {
    
    const { scrollTo } = useScrollTo();
    
    useEffect(() => {
        scrollTo('page.top', { animated: true });
    }, []);

    return (
        <Suspense fallback={null}>
            <Entry />
        </Suspense>
    )
}

export default HomeScreen;